<template>
  <div class="page">
    <div class="container">

      <element-processor
        @submit="submit"
        :data="processorData"
        @submitOtherEst="submitOtherEst"
        @getAdminRand="getAdminRand"
      >
        <element-processor-step :data="processorData.steps[0]">
          <ul class="form-item-list">
            <li><h3>펫 정보</h3></li>
            <li><element-select v-model="processorData.steps[0].formData.type.value" :error="processorData.steps[0].formData.type.error" :label="processorData.steps[0].formData.type.label" :placeholder="processorData.steps[0].formData.type.label" :items="processorData.steps[0].formData.type.items" /></li>

            <li>
              <element-textbox @search="petsearch" @keypress.enter="petsearch"
              :items="[ { label: processorData.steps[0].formData.kind.value, value: processorData.steps[0].formData.kind.value } ]"
              v-model="processorData.steps[0].formData.kind.value"
              :error="processorData.steps[0].formData.kind.error"
              :label="processorData.steps[0].formData.kind.label"
              :placeholder="processorData.steps[0].formData.kind.label" />
              <element-autocomplete v-if="autocomplete.status" @clickItem="selectedItem" :items="autocomplete.results" />
            </li>
            <div class="form-item-caution" style="padding-right:120px;">품종이 없거나 믹스견인 경우, 성견 몸무게 및 '믹스견'이라고 입력해주세요.
              <div class="button-search" @click="clickSearch">품종 검색</div>
            </div>

            <li><element-textbox v-model="processorData.steps[0].formData.birth.value" :error="processorData.steps[0].formData.birth.error" :label="processorData.steps[0].formData.birth.label" :placeholder="processorData.steps[0].formData.birth.placeholder" /></li>
            <div class="form-item-caution">정확히 모르시는 경우, 동물병원에 등록한 펫의 생년월일을 입력해 주세요.</div>

            <li><element-spread-select v-model="processorData.steps[0].formData.sex.value" :error="processorData.steps[0].formData.sex.error" :label="processorData.steps[0].formData.sex.label" :items="processorData.steps[0].formData.sex.items" /></li>
            <li><element-spread-select v-model="processorData.steps[0].formData.neutralization.value" :error="processorData.steps[0].formData.neutralization.error" :label="processorData.steps[0].formData.neutralization.label" :items="processorData.steps[0].formData.neutralization.items" /></li>
            <li><element-spread-select v-model="processorData.steps[0].formData.registration.value" :error="processorData.steps[0].formData.registration.error" :label="processorData.steps[0].formData.registration.label" :items="processorData.steps[0].formData.registration.items" /></li>
            <div class="form-item-caution">반려동물의 생일 및 품종을 사실과 다르게 알린 경우 보험금 삭감, 계약해지 등의 불이익을 받으실 수 있습니다.</div>


          </ul>
        </element-processor-step>
        <element-processor-step :data="processorData.steps[1]">
          <ul class="form-item-list">
            <li><h3>보장항목</h3></li>
            <li v-for="(options, index) in processorData.steps[1].formData.insureOptions" :key="index">
              <element-content-checkbox @status="popup" v-model="processorData.steps[1].formData.insureOptions[index].value" :error="processorData.steps[1].formData.insureOptions[index].error" :label="processorData.steps[1].formData.insureOptions[index].label" :items="processorData.steps[1].formData.insureOptions[index].items" :index="index" :requirement="processorData.steps[1].formData.insureOptions[index].requirement"/>
            </li>
          </ul>
        </element-processor-step>
        <element-processor-step :data="processorData.steps[2]">
          <ul class="form-item-list" id="history-of-treatment">
            <li><h3>치료이력</h3></li>
            <li id="history-of-treatment-item"><element-radio v-model="processorData.steps[2].formData.history.value" :error="processorData.steps[2].formData.history.error" :label="processorData.steps[2].formData.history.label" :items="processorData.steps[2].formData.history.items" /></li>
          </ul>
          <div class="form-item-caution">심질환, 신질환, 부신피질기능저하증(애디슨병), 부신피질기능항진증(쿠징증후군), 간장·담낭질환, 간문맥전신단락증, 췌장외분비부전, 당뇨병, 필라리아감염증, 악성종양, 뇌·신경질환(추간판헤르니 포함), 면역개재성용혈성빈형(AHA), 갑상선질환, 호르너증후군, 거대식도증, 관절탈구, 종지뼈탈구(슬개골탈구), 백내장, 녹내장, 고관절형성부전, 외이염, 간질, 레그페르테스, 수두증, 고양이전염성복막염(FIP), 고양이면역부전바이러스감염증(FeLV),
            고양이백혈병바이러스감염증(FIV), 바베시아증, 헤모바토넬라감염증, 기타선천성이상 및 선천성질병</div>

        </element-processor-step>

        <element-processor-step :data="processorData.steps[3]">
          <include-estimate-auth-self @updateprocessorData="updateprocessorData" />
        </element-processor-step>

        <element-processor-step :data="processorData.steps[4]" class="consult-step">
          <div class="left">
            <ul class="form-item-list" style="min-height: 600px;">
              <li>
                <!-- <div class="form-item-caution">상담예약을 하시면 인수가능한 정확한 보험료와 5대 보증 6대 사은 서비스 안내 받고 <b style="color:#174be6; font-weight: bold;"> 매년 편리하게 유리한 보험사로 가입</b>하실 수 있습니다.</div> -->
                <h1 class="title">상담을 통해 나에게<br /><b>유리한 조건</b>의 보험사로 가입하세요!</h1>
                <p class="text">보험 가입 시 5대 보증 6대 사은 서비스를 무료로 제공해드립니다.</p>
              </li>
              <li class="desc">
                <div
                  class="card-list"
                  v-for="(item, index) in consultList"
                  :key="index"
                >
                  <img :src="`/static/compare/modal/icon${index + 1}.png`" :alt="item.title" />
                  <h1>{{ item.title }}</h1>
                  <p>{{ item.text }}</p>
                </div>
              </li>
              <li class="column">
                <h1 class="label"><b>상담예약</b> 일시</h1>
                <div class="column">
                  <div class="left-form">
                    <element-calendar
                      v-model="processorData.steps[4].formData.consultDate.value"
                      :error="processorData.steps[4].formData.consultDate.error"
                      :placeholder="processorData.steps[4].formData.consultDate.placeholder"
                    />
                    <element-time-select
                      v-model="processorData.steps[4].formData.consultTime.value" 
                      :date="processorData.steps[4].formData.consultDate.value"
                      :error="processorData.steps[4].formData.consultTime.error"
                      :placeholder="processorData.steps[4].formData.consultTime.placeholder"
                    />
                    <element-textarea
                      v-model="processorData.steps[4].formData.consultRemark.value"
                      :error="processorData.steps[4].formData.consultRemark.error"
                      :placeholder="processorData.steps[4].formData.consultRemark.placeholder"
                    />
                  </div>
                  <div class="right-button">
                    <button @click="clickEventHandler">
                      <img src="/static/compare/modal/submit.png" alt="상담예약"/>
                      <p>상담예약</p>
                    </button>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <div class="right">
            <div class="header">
              <h1>make sure your sure</h1>
              <p>고객의 확신에 우리의 확실을 더합니다.</p>
            </div>
            
            <div class="footer">
              <div class="admin">
                <div class="avatar">
                  <img :src="admin.resource_url" :alt="admin.admin_name" />
                </div>
                <p><span>{{ admin.admin_name }}</span> 금융상품판매대리인</p>
              </div>
              <div class="speech-bubble">고객님께서 놓치시는 혜택이 없도록 세세하고 친절하게 상담해드립니다!</div>
            </div>
          </div>
        </element-processor-step>
        <element-processor-step :data="processorData.steps[5]">
          <include-estimate-complete :data="processorData.steps[5]" />
        </element-processor-step>

        <element-processor-step :data="processorData.steps[6]">
          <include-other-estimate :data="processorData.steps[6]"  :type="processorData.title"/>
        </element-processor-step>

        <transition name="popup">
          <element-popup-search-pet :tab="processorData.steps[0].formData.type.value" @status="popupSearchPet" @checkPet="checkPet" :subLabel="processorData.steps[0].formData.kind.value" v-model="processorData.steps[0].formData.kind.value" :label="'품종 검색'" v-if="statusSearchPopup" :statusPopup="statusSearchPopup">
          </element-popup-search-pet>
        </transition>

        <transition name="popup">
          <element-popup @status="popup" :process_title="processorData.title" v-model="processorData.steps[1].formData.insureOptions[statusPopup.option].value" @checkPopup="checkValue" :label="processorData.steps[1].formData.insureOptions[statusPopup.option].items[statusPopup.index].label"
          :subLabel="processorData.steps[1].formData.insureOptions[statusPopup.option].items[statusPopup.index].subLabel" v-if="statusPopup.popup" :statusPopup="statusPopup" :data="processorData.steps[1].formData.insureOptions[statusPopup.option]"
          :description="processorData.steps[1].formData.insureOptions[statusPopup.option].items[statusPopup.index].description">
          </element-popup>
        </transition>

      </element-processor>
    </div>
  </div>
</template>

<style lang="scss">
.element-processor > main .body {
    /*position: relative;*/
}
.button-search{
    position: absolute;
    right: 7px;
    top: 0;
    bottom: 0;
    height: 36px;
    margin: auto;
    width: 80px;
    padding: 5px;
    text-align: center;
    background-color: #0b2573;
    color: white;
    border-radius: 3px;
}
</style>

<script>

import moment from 'moment'
import { EventBus } from '@/plugins/event-bus';

export default {
  data(){
    return {
      statusPopup: {
        popup: false,
        index: '',
        option: -1,
      },
      autocomplete: {
        items: [],
        results: [],
        status: false,
      },
      statusSearchPopup: false,
      moment: moment,
      processorData: {
        title: "펫보험 견적서",
        steps: [
          {
            title: "펫 정보",
            formData: {
              type: {
                label: "펫 구분",
                value: "",
                error: "",
                items: [
                  { value: "강아지", label: "강아지" },
                  { value: "고양이", label: "고양이" }
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              kind: {
                label: "펫 품종",
                value: "",
                error: "",
                placeholder: "품종 입력",
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              birth: {
                label: "펫 생일",
                value: "",
                error: "",
                placeholder: "생년월일 6자리 입력",
                validations: [
                  { type: "required", message: "필수항목입니다" },
                  { type: "birth", message: "예) 950101" },
                ]
              },
              sex: {
                label: "펫 성별",
                value: "",
                error: "",
                items: [
                  { value: "남자", label: "남자" },
                  { value: "여자", label: "여자" },
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              neutralization: {
                label: "중성화 수술",
                value: "",
                error: "",
                items: [
                  { value: "예", label: "예" },
                  { value: "아니요", label: "아니요" }
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              registration: {
                label: "반려동물 등록",
                value: "",
                error: "",
                items: [
                  { value: "예", label: "예" },
                  { value: "아니요", label: "아니요" }
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              }
            }
          },
          {
            title: "보장항목",
            formData:
            {
              insureOptions: [
              {
                label: "보장 내용",
                requirement: true,
                value: [
                  { label: "자기부담금 치료비", value: "자기부담금 치료비 30%" },
                  { label: "통원의료비", value: "100만원 한도" },
                  { label: "입원의료비", value: "100만원 한도" }
                ],
                error: "",
                items: [
                  { value: "자기부담금 치료비", label: "자기부담금 치료비", description: [
                    { value: "반려동물이 보험기간중 진단확정된 질병 또는 상해를 입었을 때 수술치료를 받아 피보험자가 보험기간중 부담한 치료비에 대해서 피보험자에게 보험가입금액을 한도로 보험금을 지급합니다.(단. 국내에서 받은 진료만 보상합니다.)" }
                  ], subLabel: "자기부담금 치료비 30%", link: { name: "Home" },
                    options: [
                      { value: "자기부담금 치료비 50%", label: "자기부담금 치료비 50%" },
                      { value: "자기부담금 치료비 30%", label: "자기부담금 치료비 30%" },

                    ] },
                  { value: "통원의료비", label: "통원의료비", description: [
                    { value: "반려동물이 보험기간중 진단확정된 질병 또는 상해를 입었을 때 통원치료를 받아 피보험자가 보험기간중 부담한 치료비에 대해서 피보험자에게 보험가입금액을 한도로 보험금을 지급합니다.(단. 국내에서 받은 진료만 보상합니다." }
                  ], subLabel: "100만원 한도", link: { name: "Home" },
                    options: [
                      { value: "500만원 한도", label: "500만원 한도" },
                      { value: "150만원 한도", label: "150만원 한도" },
                      { value: "100만원 한도", label: "100만원 한도" },
                    ] },
                  { value: "입원의료비", label: "입원의료비", description: [
                    { value: "반려동물이 보험기간중 진단확정된 질병 또는 상해를 입었을 때 통원치료를 받아 피보험자가 보험기간중 부담한 치료비에 대해서 피보험자에게 보험가입금액을 한도로 보험금을 지급합니다.(단. 국내에서 받은 진료만 보상합니다." }
                  ], subLabel: "100만원 한도", link: { name: "Home" },
                    options: [
                      { value: "500만원 한도", label: "500만원 한도" },
                      { value: "150만원 한도", label: "150만원 한도" },
                      { value: "100만원 한도", label: "100만원 한도" },

                    ] },
                ],
              },
              {
                label: "추가 특약",
                requirement: false,
                value: [],
                error: "",
                items: [
                  { value: "배상책임", label: "배상책임", description: [
                    { value: "반려동물이 타인의 신체나 타인 소유의 반려동물에 손해를 입힌 경우" }
                  ], subLabel: "미가입", link: { name: "Home" },
                    options: [
                      { value: "1,000만원 한도", label: "1,000만원 한도" },
                      { value: "500만원 한도", label: "500만원 한도" },
                      { value: "미가입", label: "미가입" },
                    ] },
                  { value: "장례비", label: "장례비", description: [
                    { value: " 반려동물이 사망(적법하게 시행된 안락사 포함)한 경우" }
                  ], subLabel: "미가입", link: { name: "Home" },
                    options: [
                      { value: "15만원", label: "15만원" },
                      { value: "미가입", label: "미가입" },
                    ] },
                ]
              }]
            }
          },
          {
            title: "치료이력",
            formData: {
              history: {
                label: "과거부터 현재까지 아래의 병으로 진단받은 적이 있습니까?",
                value: "",
                error: "",
                items: [
                  { value: "있음", label: "있음" },
                  { value: "없음", label: "없음" },
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
            }
          },
          {
            title: "본인 확인",
            formData: {
              /*haslogin: {
                value: "",
                validations: [
                  { type: "required", message: "-" }
                ]
              },*/
              phone: {
                label: "휴대폰 번호",
                value: "",
                validations: [
                  { type: "required", message: "-" }
                ]
              },
              name: {
                label: "이름",
                value: "",
                validations: [
                  { type: "required", message: "-" }
                ]
              },
              email: {
                label: "이메일",
                value: "",
                /*validations: [
                  { type: "required", message: "-" }
                ]*/
              },
              birth: {
                label: "생년월일",
                value: "",
                validations: [
                  { type: "required", message: "-" },
                ]
              },
            }
          },
          {
            title: "상담 예약",
            formData: {
              consultDate: {
                label: "상담 예약 일시",
                value: new Date(),
                error: "",
                placeholder: "날짜"
              },
              consultTime: {
                label: "상담 예약 일시",
                value: "",
                error: "",
                placeholder: "시간",
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              consultRemark: {
                label: "상담 전 남기실 말씀",
                value: "",
                error: "",
                placeholder: "특별히 보장 받고 싶은 보장 항목, 기간, 금액 또는 현재 가입 중인 보험 그리고 상담 전 남기실 말씀을 입력하십시오. (200자 이내)"
              },
            }
          },
          {
            title: "비교견적 신청이 완료되었습니다.",
            label: "입력하신 정보를 바탕으로 쉽게 추가 견적서를 신청하시겠습니까?"
          },
          {
            title: "다른 보험 표준 견적서 받아보기",
            label: "",
            value: []
          }
        ] // steps
      },
      dogList: [
        { label: "갈고 에스파뇨르", keyword: 'ㄱ' },
        { label: "가스콩 생통주아", keyword: 'ㄱ' },
        { label: "글렌 오브 이말 테리어", keyword: 'ㄱ' },
        { label: "골든 리트리버", keyword: 'ㄱ' },
        { label: "고든 세터", keyword: 'ㄱ' },
        { label: "그레이트 데인", keyword: 'ㄱ' },
        { label: "그레이트 피레니즈", keyword: 'ㄱ' },
        { label: "그레이터 스위스 마운틴 도그", keyword: 'ㄱ' },
        { label: "그릭 헤어하운드", keyword: 'ㄱ' },
        { label: "그린랜드 도그", keyword: 'ㄱ' },
        { label: "그레이하운드", keyword: 'ㄱ' },
        { label: "그리퐁 방뎅", keyword: 'ㄱ' },
        { label: "기주견", keyword: 'ㄱ' },
        { label: "골든 두들", keyword: 'ㄱ' },

        { label: "나폴리탄 마스티프(네오폴리탄 마스티프)", keyword: 'ㄴ' },
        { label: "뉴 기니아 싱잉 도그", keyword: 'ㄴ' },
        { label: "뉴펀들랜드", keyword: 'ㄴ' },
        { label: "노르보텐 스피츠", keyword: 'ㄴ' },
        { label: "노퍽 테리어", keyword: 'ㄴ' },
        { label: "노르웰지안 부훈트", keyword: 'ㄴ' },
        { label: "노르웨이 엘크 하운드", keyword: 'ㄴ' },
        { label: "노리치 테이러", keyword: 'ㄴ' },
        { label: "노바 스코셔 덕 톨링 리트리버", keyword: 'ㄴ' },

        { label: "닥스훈트", keyword: 'ㄷ' },
        { label: "달마시안", keyword: 'ㄷ' },
        { label: "댄디 딘몬트 테리어", keyword: 'ㄷ' },
        { label: "대니쉬 브로홀머(대니쉬 마스티프)", keyword: 'ㄷ' },
        { label: "도이치 브라케", keyword: 'ㄷ' },
        { label: "딩고", keyword: 'ㄷ' },
        { label: "도베르만(도베르만 핀셔)", keyword: 'ㄷ' },
        { label: "도고 아르젠티노", keyword: 'ㄷ' },
        { label: "도그 드 보르도", keyword: 'ㄷ' },
        { label: "동경견(동경이, 경주견, 경주개)", keyword: 'ㄷ' },
        { label: "도사견", keyword: 'ㄷ' },
        { label: "드렌체 파트리죤드", keyword: 'ㄷ' },
        { label: "드레버", keyword: 'ㄷ' },
        { label: "던커", keyword: 'ㄷ' },
        { label: "더치 세퍼드", keyword: 'ㄷ' },
        { label: "더치 스무숀드", keyword: 'ㄷ' },

        { label: "레브라도 리트리버", keyword: 'ㄹ' },
        { label: "레이크랜드 테리어", keyword: 'ㄹ' },
        { label: "랭카셔 힐러", keyword: 'ㄹ' },
        { label: "랜드시어", keyword: 'ㄹ' },
        { label: "랩핀포로코이라", keyword: 'ㄹ' },
        { label: "라프훈트", keyword: 'ㄹ' },
        { label: "라트비안 하운드", keyword: 'ㄹ' },
        { label: "레온베르거", keyword: 'ㄹ' },
        { label: "르베스크", keyword: 'ㄹ' },
        { label: "라사압소", keyword: 'ㄹ' },
        { label: "리트아니안 하운드", keyword: 'ㄹ' },
        { label: "로첸", keyword: 'ㄹ' },
        { label: "룬데훈트", keyword: 'ㄹ' },
        { label: "라페이로 도 알렌테조 (포루투기스 마스티프)", keyword: 'ㄹ' },
        { label: "레드본 쿤하운드", keyword: 'ㄹ' },
        { label: "로디지아 리지백", keyword: 'ㄹ' },
        { label: "로트와일러", keyword: 'ㄹ' },
        { label: "러시안 할리퀸 하운드", keyword: 'ㄹ' },
        { label: "라시안 하운드", keyword: 'ㄹ' },
        { label: "러시안 스파네일", keyword: 'ㄹ' },
        { label: "러시안 토이(러시안 토이 테리어", keyword: 'ㄹ' },
        { label: "라고토 로마그놀로", keyword: 'ㄹ' },
        { label: "랫 테리어", keyword: 'ㄹ' },

        { label: "마쟈르 아가르", keyword: 'ㅁ' },
        { label: "말티즈(몰티즈)", keyword: 'ㅁ' },
        { label: "말티푸", keyword: 'ㅁ' },
        { label: "맨체스터 테리어", keyword: 'ㅁ' },
        { label: "마렘마 쉽독", keyword: 'ㅁ' },
        { label: "마르키쉬에", keyword: 'ㅁ' },
        { label: "마스티프", keyword: 'ㅁ' },
        { label: "미디엄 푸들", keyword: 'ㅁ' },
        { label: "미들 아시안 오브차카", keyword: 'ㅁ' },
        { label: "미니어처 불 테리어", keyword: 'ㅁ' },
        { label: "미니어처 닥스훈트", keyword: 'ㅁ' },
        { label: "미니어처 핀셔", keyword: 'ㅁ' },
        { label: "미니어쳐 푸들", keyword: 'ㅁ' },
        { label: "미니어처 슈나우저", keyword: 'ㅁ' },

        { label: "발리 마운틴 도그 (킨타마니)", keyword: 'ㅂ' },
        { label: "바베트", keyword: 'ㅂ' },
        { label: "바센지", keyword: 'ㅂ' },
        { label: "바셋 아르테지안 노르만", keyword: 'ㅂ' },
        { label: "바셋 하운드", keyword: 'ㅂ' },
        { label: "바바리안 마운틴 하운드", keyword: 'ㅂ' },
        { label: "비글", keyword: 'ㅂ' },
        { label: "비글 해리어", keyword: 'ㅂ' },
        { label: "비어디드 콜리", keyword: 'ㅂ' },
        { label: "보스롱 (베르제 드 보스)", keyword: 'ㅂ' },
        { label: "베들링턴 테리어", keyword: 'ㅂ' },
        { label: "벨지안 그리퐁", keyword: 'ㅂ' },
        { label: "벨기에 말리노이즈", keyword: 'ㅂ' },
        { label: "벨기에 쉽독", keyword: 'ㅂ' },
        { label: "벨기에 테뷰런", keyword: 'ㅂ' },
        { label: "벨가마스코", keyword: 'ㅂ' },
        { label: "베르제 드 피카르", keyword: 'ㅂ' },
        { label: "베르제 드 피레네즈", keyword: 'ㅂ' },
        { label: "버니즈 마운틴 도그", keyword: 'ㅂ' },
        { label: "비숑 프리제", keyword: 'ㅂ' },
        { label: "빌리", keyword: 'ㅂ' },
        { label: "블랙 앤드 탄 쿤하운드", keyword: 'ㅂ' },
        { label: "블랙 러시안 테리어", keyword: 'ㅂ' },
        { label: "블루 드 가스코뉴", keyword: 'ㅂ' },
        { label: "블러드 하운드", keyword: 'ㅂ' },
        { label: "블루틱 쿤하운드", keyword: 'ㅂ' },
        { label: "보어보엘 (보볼, 남아프리카 마스티프)", keyword: 'ㅂ' },
        { label: "볼르그네제", keyword: 'ㅂ' },
        { label: "보더 콜리", keyword: 'ㅂ' },
        { label: "보더 테리어", keyword: 'ㅂ' },
        { label: "보르조이", keyword: 'ㅂ' },
        { label: "보스턴 테리어", keyword: 'ㅂ' },
        { label: "부비에 데 플랑드르", keyword: 'ㅂ' },
        { label: "복서", keyword: 'ㅂ' },
        { label: "보이킨 스파니엘", keyword: 'ㅂ' },
        { label: "브라꼬 이탈리아노", keyword: 'ㅂ' },
        { label: "브라크 다 리에쥐", keyword: 'ㅂ' },
        { label: "브라크 다 베르뉴", keyword: 'ㅂ' },
        { label: "브라크 뒤 부르보네", keyword: 'ㅂ' },
        { label: "브라크 뒤퓌이 (브라크 프랑세)", keyword: 'ㅂ' },
        { label: "브라크 생 제르맹", keyword: 'ㅂ' },
        { label: "브리아드", keyword: 'ㅂ' },
        { label: "브리타니 (브리타니 스파니엘)", keyword: 'ㅂ' },
        { label: "브뤼셀 그리핀", keyword: 'ㅂ' },
        { label: "불 테리어", keyword: 'ㅂ' },
        { label: "불독", keyword: 'ㅂ' },
        { label: "불 마스티프", keyword: 'ㅂ' },
        { label: "바스코타 스펫츠 (스위디시 발훈트)", keyword: 'ㅂ' },
        { label: "비즐라", keyword: 'ㅂ' },
        { label: "볼피노 이탈리아노", keyword: 'ㅂ' },


        { label: "시영 프랑세즈", keyword: 'ㅅ' },
        { label: "샤페이 (차이니즈 샤페이)", keyword: 'ㅅ' },
        { label: "시르네코 델레트나", keyword: 'ㅅ' },
        { label: "사르로스울프 하운드", keyword: 'ㅅ' },
        { label: "사부에소 에소파뇰", keyword: 'ㅅ' },
        { label: "세인트 버나드", keyword: 'ㅅ' },
        { label: "살루키", keyword: 'ㅅ' },
        { label: "사모예드", keyword: 'ㅅ' },
        { label: "삽살개", keyword: 'ㅅ' },
        { label: "사플라니낙", keyword: 'ㅅ' },
        { label: "삭펜도스", keyword: 'ㅅ' },
        { label: "스첼스퇴바레", keyword: 'ㅅ' },
        { label: "스키퍼키", keyword: 'ㅅ' },
        { label: "스코티시 디어하운드", keyword: 'ㅅ' },
        { label: "소크티시 테리어", keyword: 'ㅅ' },
        { label: "실리엄 테리어", keyword: 'ㅅ' },
        { label: "세구지오 이탈리아노", keyword: 'ㅅ' },
        { label: "셰터", keyword: 'ㅅ' },
        { label: "셔틀랜드 쉽독", keyword: 'ㅅ' },
        { label: "시바 이누", keyword: 'ㅅ' },
        { label: "시추", keyword: 'ㅅ' },
        { label: "시코쿠 (시꼬꾸)", keyword: 'ㅅ' },
        { label: "시베리안 허스키 (시베리언 허스키)", keyword: 'ㅅ' },
        { label: "시베리안 라이카", keyword: 'ㅅ' },
        { label: "실키 테리어", keyword: 'ㅅ' },
        { label: "스카이 테리어", keyword: 'ㅅ' },
        { label: "슬루기", keyword: 'ㅅ' },
        { label: "슬로바크 쿠바", keyword: 'ㅅ' },
        { label: "슬로바키안 하운드", keyword: 'ㅅ' },
        { label: "소프트 코티드 휘튼 테리어", keyword: 'ㅅ' },
        { label: "사우스 러시안 오브차카", keyword: 'ㅅ' },
        { label: "스페니쉬 마스티프", keyword: 'ㅅ' },
        { label: "스페니쉬 포인터", keyword: 'ㅅ' },
        { label: "스피노네 이탈리아노", keyword: 'ㅅ' },
        { label: "스피츠", keyword: 'ㅅ' },
        { label: "스테비 훈", keyword: 'ㅅ' },
        { label: "스테포드셔 불 테리어", keyword: 'ㅅ' },
        { label: "스테퍼드셔 불 테리어", keyword: 'ㅅ' },
        { label: "스탠다드 푸들", keyword: 'ㅅ' },
        { label: "스탠다드 슈나우져", keyword: 'ㅅ' },
        { label: "스티첼할", keyword: 'ㅅ' },
        { label: "스트렐루프스퇴바레", keyword: 'ㅅ' },
        { label: "스틸리안 마운틴 하운드", keyword: 'ㅅ' },
        { label: "서섹스 스파니엘", keyword: 'ㅅ' },
        { label: "스위스 하운드", keyword: 'ㅅ' },
        { label: "쇼로이츠퀸틀리", keyword: 'ㅅ' },
        { label: "스무스 콜리", keyword: 'ㅅ' },

        { label: "아펜핀셔", keyword: 'ㅇ' },
        { label: "아프칸 하운드", keyword: 'ㅇ' },
        { label: "에이디 (시앵 드 라틀라스)", keyword: 'ㅇ' },
        { label: "아이누견", keyword: 'ㅇ' },
        { label: "에어데일 테리어", keyword: 'ㅇ' },
        { label: "아크바시 도그", keyword: 'ㅇ' },
        { label: "아키타", keyword: 'ㅇ' },
        { label: "알래스칸 클리카이", keyword: 'ㅇ' },
        { label: "알래스칸 말라뮤트", keyword: 'ㅇ' },
        { label: "알핀 닥스브라케", keyword: 'ㅇ' },
        { label: "아메리칸 블랙 앤 쿤하운드", keyword: 'ㅇ' },
        { label: "아메리칸 불독", keyword: 'ㅇ' },
        { label: "아메리칸 불리 (불리)", keyword: 'ㅇ' },
        { label: "에스키모 도그 (아메리칸 에스키모 도그)", keyword: 'ㅇ' },
        { label: "아메리칸 폭스하운드", keyword: 'ㅇ' },
        { label: "아메리칸 핏 불 테리어", keyword: 'ㅇ' },
        { label: "아메리칸 스테포드셔 테리어", keyword: 'ㅇ' },
        { label: "아메리칸 워터 스파니엘", keyword: 'ㅇ' },
        { label: "아나톨리아 셰퍼드 도그 (아나톨리안 카바라시 도그)", keyword: 'ㅇ' },
        { label: "앨글로 프랑세즈", keyword: 'ㅇ' },
        { label: "아펜젤러", keyword: 'ㅇ' },
        { label: "아리에쥬아", keyword: 'ㅇ' },
        { label: "아르투아 하운드 (시엥 다르투아)", keyword: 'ㅇ' },
        { label: "오스트레일리언 캐틀 도그", keyword: 'ㅇ' },
        { label: "오스트레일리언 켈피", keyword: 'ㅇ' },
        { label: "오스트레일리언 셰퍼드", keyword: 'ㅇ' },
        { label: "오스트레일리언 테리어", keyword: 'ㅇ' },
        { label: "오스트리아 브랜들브라케", keyword: 'ㅇ' },
        { label: "오스트리아 숏트헤어드 핀셔", keyword: 'ㅇ' },
        { label: "아자와크", keyword: 'ㅇ' },
        { label: "아메리칸 코카 스파니엘 (코커 스파니엘)", keyword: 'ㅇ' },
        { label: "이스트 러시안 코오싱 하운드", keyword: 'ㅇ' },
        { label: "엘크하운드", keyword: 'ㅇ' },
        { label: "잉글리시 코카 스파니엘 (잉글리쉬 코커 스파니엘)", keyword: 'ㅇ' },
        { label: "잉글리시 쿤하운드", keyword: 'ㅇ' },
        { label: "잉글리시 폭스하운드", keyword: 'ㅇ' },
        { label: "잉글리시 포인터", keyword: 'ㅇ' },
        { label: "잉글리시 셰터", keyword: 'ㅇ' },
        { label: "잉글리시 셰퍼드", keyword: 'ㅇ' },
        { label: "잉글리시 스프링어 스파니엘", keyword: 'ㅇ' },
        { label: "잉글리시 토이 스파니엘", keyword: 'ㅇ' },
        { label: "엔텔부쳐", keyword: 'ㅇ' },
        { label: "에피뉴엘 프랑세", keyword: 'ㅇ' },
        { label: "에피뉴엘 파카르디", keyword: 'ㅇ' },
        { label: "에피뉴엘 퐁 오드메", keyword: 'ㅇ' },
        { label: "에스토니아 하운드", keyword: 'ㅇ' },
        { label: "에스트렐라 마운틴 도그", keyword: 'ㅇ' },
        { label: "유라시안", keyword: 'ㅇ' },
        { label: "이비전 하운드", keyword: 'ㅇ' },
        { label: "아이슬란드 도그", keyword: 'ㅇ' },
        { label: "잉카 헤어리스 도그 (페루비안 잉카 오키드)", keyword: 'ㅇ' },
        { label: "아이리시 레드 앤 화이트 세터", keyword: 'ㅇ' },
        { label: "아이리시 세터", keyword: 'ㅇ' },
        { label: "아이리시 테리어", keyword: 'ㅇ' },
        { label: "아이리시 워터 스파니엘", keyword: 'ㅇ' },
        { label: "아이리시 울프 하운드", keyword: 'ㅇ' },
        { label: "이탤리언 그레이하운드", keyword: 'ㅇ' },
        { label: "올드 데니쉬 버드 도그", keyword: 'ㅇ' },
        { label: "올드 잉글리쉬 쉽독", keyword: 'ㅇ' },
        { label: "올드 잉글리쉬 불독", keyword: 'ㅇ' },
        { label: "오터 하운드", keyword: 'ㅇ' },
        { label: "오우짜렉 포드할안스키", keyword: 'ㅇ' },
        { label: "웰시 코기 (펨브록 웰시 코기)", keyword: 'ㅇ' },
        { label: "와니머라너", keyword: 'ㅇ' },
        { label: "웰시 스프링어 스파니엘", keyword: 'ㅇ' },
        { label: "웰시 테리어", keyword: 'ㅇ' },
        { label: "웨스트 하이랜드 화이트 테리어", keyword: 'ㅇ' },
        { label: "웨스트팔라안 닥스브라케", keyword: 'ㅇ' },
        { label: "웨터훈", keyword: 'ㅇ' },
        { label: "와이어헤어드 포인팅 그리펀", keyword: 'ㅇ' },
        { label: "요크셔 테리어", keyword: 'ㅇ' },
        { label: "유고슬라비안 하운드", keyword: 'ㅇ' },
        { label: "아이리시 잭 러셀 테리어", keyword: 'ㅇ' },

        { label: "저먼 스파니엘 (도이체르 바흐텔훈트)", keyword: 'ㅈ' },
        { label: "저먼 헌트 테리어", keyword: 'ㅈ' },
        { label: "저먼 롱헤어드 포인터", keyword: 'ㅈ' },
        { label: "저먼 핀셔", keyword: 'ㅈ' },
        { label: "저먼 포인터", keyword: 'ㅈ' },
        { label: "저먼 셰퍼드 도그", keyword: 'ㅈ' },
        { label: "저면 쇼트페어드 포인터", keyword: 'ㅈ' },
        { label: "저먼 스피츠", keyword: 'ㅈ' },
        { label: "저먼 와이어헤어드 포인터", keyword: 'ㅈ' },
        { label: "자이언트 슈나우저", keyword: 'ㅈ' },
        { label: "잭 러셀 테리어", keyword: 'ㅈ' },
        { label: "제페니즈 친", keyword: 'ㅈ' },
        { label: "제페니즈 미들 사이즈 도그", keyword: 'ㅈ' },
        { label: "제피니즈 스피츠", keyword: 'ㅈ' },
        { label: "진돗개", keyword: 'ㅈ' },
        { label: "장모 치와와", keyword: 'ㅈ' },

        { label: "체스키 포섹", keyword: 'ㅊ' },
        { label: "체서피크 베이 리트리버", keyword: 'ㅊ' },
        { label: "치와와", keyword: 'ㅊ' },
        { label: "차이니스 크레스티드", keyword: 'ㅊ' },
        { label: "차우차우", keyword: 'ㅊ' },
        { label: "체코슬로바키안 울프독 (체코울프독)", keyword: 'ㅊ' },
        { label: "체스키 테리어", keyword: 'ㅊ' },

        { label: "케언 테리어", keyword: 'ㅋ' },
        { label: "케이넌 도그", keyword: 'ㅋ' },
        { label: "카네 코르소 (케인 코르소)", keyword: 'ㅋ' },
        { label: "카오 다 세라 데 아이레스", keyword: 'ㅋ' },
        { label: "카오 데 카스트로 라보레이로", keyword: 'ㅋ' },
        { label: "카디건 웰시 코기", keyword: 'ㅋ' },
        { label: "카탈란 쉽독", keyword: 'ㅋ' },
        { label: "코카시안 오프차카", keyword: 'ㅋ' },
        { label: "카발리에 킹 찰스 스파니엘", keyword: 'ㅋ' },
        { label: "클럼버 스파니엘", keyword: 'ㅋ' },
        { label: "콜리", keyword: 'ㅋ' },
        { label: "크로아티안 쉽독", keyword: 'ㅋ' },
        { label: "컬리코티드 리트리버", keyword: 'ㅋ' },
        { label: "카이견", keyword: 'ㅋ' },
        { label: "캉갈 도그 (캉갈)", keyword: 'ㅋ' },
        { label: "카레리언 베어 라이카", keyword: 'ㅋ' },
        { label: "카렐로-피니쉬 라이카", keyword: 'ㅋ' },
        { label: "케이스혼트", keyword: 'ㅋ' },
        { label: "케리 블루 테리어", keyword: 'ㅋ' },
        { label: "코몬도르", keyword: 'ㅋ' },
        { label: "쿠이거혼제", keyword: 'ㅋ' },
        { label: "크라스키 오브카", keyword: 'ㅋ' },
        { label: "크롬포흘뢴더", keyword: 'ㅋ' },
        { label: "쿠바스", keyword: 'ㅋ' },
        { label: "케니스 팬더", keyword: 'ㅋ' },

        { label: "텔로미언", keyword: 'ㅌ' },
        { label: "티베티안 마스티프 (티베탄 마스티프)", keyword: 'ㅌ' },
        { label: "티베탄 스파니엘", keyword: 'ㅌ' },
        { label: "티베탄 테리어", keyword: 'ㅌ' },
        { label: "토이 폭스 테리어", keyword: 'ㅌ' },
        { label: "토이 맨채스터 테리어", keyword: 'ㅌ' },
        { label: "토이 푸들", keyword: 'ㅌ' },
        { label: "트랜실바니안 하운드", keyword: 'ㅌ' },
        { label: "트링 워커 쿤하운드", keyword: 'ㅌ' },
        { label: "티롤러 브라케", keyword: 'ㅌ' },

        { label: "파피용 (콘티넨탈 토이 스파니엘)", keyword: 'ㅍ' },
        { label: "포브 드 브르타뉴", keyword: 'ㅍ' },
        { label: "필드 스파니엘", keyword: 'ㅍ' },
        { label: "필라 브라질레이로", keyword: 'ㅍ' },
        { label: "피니쉬 하운드", keyword: 'ㅍ' },
        { label: "피니시 스피츠", keyword: 'ㅍ' },
        { label: "플랫코티드 리트리버", keyword: 'ㅍ' },
        { label: "폭스 테리어 (스무드)", keyword: 'ㅍ' },
        { label: "폭스 테리어 (와이어)", keyword: 'ㅍ' },
        { label: "프렌치 불독", keyword: 'ㅍ' },
        { label: "페키니즈", keyword: 'ㅍ' },
        { label: "프티 바세 그리퐁 방댕", keyword: 'ㅍ' },
        { label: "프티 브라반숑", keyword: 'ㅍ' },
        { label: "파라오 하운드", keyword: 'ㅍ' },
        { label: "플롯 하운드", keyword: 'ㅍ' },
        { label: "포인터", keyword: 'ㅍ' },
        { label: "프와트뱅", keyword: 'ㅍ' },
        { label: "폴리쉬 그레이 하운드", keyword: 'ㅍ' },
        { label: "폴리쉬 하운드", keyword: 'ㅍ' },
        { label: "폴리시 롤런드 쉽독", keyword: 'ㅍ' },
        { label: "포메라니안", keyword: 'ㅍ' },
        { label: "폼피츠", keyword: 'ㅍ' },
        { label: "폼스키", keyword: 'ㅍ' },
        { label: "포르셀엔", keyword: 'ㅍ' },
        { label: "포르투갈 워터 도그", keyword: 'ㅍ' },
        { label: "푸델 포인터", keyword: 'ㅍ' },
        { label: "퍼그", keyword: 'ㅍ' },
        { label: "풀리", keyword: 'ㅍ' },
        { label: "푸미", keyword: 'ㅍ' },
        { label: "피레니안 마스티프", keyword: 'ㅍ' },
        { label: "파슨 러셀 테리어", keyword: 'ㅍ' },

        { label: "호르타이", keyword: 'ㅎ' },
        { label: "할델스퇴바레", keyword: 'ㅎ' },
        { label: "해밀톤스퇴바레", keyword: 'ㅎ' },
        { label: "해리어", keyword: 'ㅎ' },
        { label: "허배너스", keyword: 'ㅎ' },
        { label: "훗카이도 (호카이도)", keyword: 'ㅎ' },
        { label: "호바와트", keyword: 'ㅎ' },
        { label: "하이젠훈트", keyword: 'ㅎ' },
        { label: "휘핏", keyword: 'ㅎ' },
        { label: "화이트 셰퍼드 도그", keyword: 'ㅎ' },

        { label: "기타/믹스견 (5kg 이하)", keyword: 'ETC/믹스견' },
        { label: "기타/믹스견 (5kg 초과 15kg 이하)", keyword: 'ETC/믹스견' },
        { label: "기타/믹스견 (15kg 초과 25kg 이하)", keyword: 'ETC/믹스견' },
        { label: "기타/믹스견 (25kg 초과 35kg 이하)", keyword: 'ETC/믹스견' },
        { label: "기타/믹스견 (35kg 초과)", keyword: 'ETC/믹스견' },
      ],

      catList: [
        { label: "네벨룽", keyword: 'ㄴ' },
        { label: "노르웨이 숲", keyword: 'ㄴ' },

        { label: "데본렉스", keyword: 'ㄷ' },
        { label: "돈스코이", keyword: 'ㄷ' },

        { label: "라가 머핀", keyword: 'ㄹ' },
        { label: "라이코이", keyword: 'ㄹ' },
        { label: "라팜(라펌)", keyword: 'ㄹ' },
        { label: "라팜(라펌) 숏헤어", keyword: 'ㄹ' },
        { label: "랙돌(래그돌)", keyword: 'ㄹ' },
        { label: "러시안 블루", keyword: 'ㄹ' },

        { label: "맹크스", keyword: 'ㅁ' },
        { label: "먼치킨", keyword: 'ㅁ' },
        { label: "먼치킨 롱헤어", keyword: 'ㅁ' },
        { label: "메인 쿤", keyword: 'ㅁ' },
        { label: "메인 쿤 폴리델틱", keyword: 'ㅁ' },
        { label: "미뉴에트", keyword: 'ㅁ' },
        { label: "미뉴에트 롱헤어", keyword: 'ㅁ' },

        { label: "발리니즈", keyword: 'ㅂ' },
        { label: "버만", keyword: 'ㅂ' },
        { label: "버미즈 (버마 고양이)", keyword: 'ㅂ' },
        { label: "버밀라", keyword: 'ㅂ' },
        { label: "버밀라 롱헤어", keyword: 'ㅂ' },
        { label: "벵갈", keyword: 'ㅂ' },
        { label: "벵갈 롱헤어", keyword: 'ㅂ' },
        { label: "봄베이", keyword: 'ㅂ' },
        { label: "브리티쉬 롱헤어", keyword: 'ㅂ' },
        { label: "브리티쉬 숏헤어", keyword: 'ㅂ' },

        { label: "사바나 캣", keyword: 'ㅅ' },
        { label: "샤트룩스", keyword: 'ㅅ' },
        { label: "샴 (샤미즈)", keyword: 'ㅅ' },
        { label: "세렝게티", keyword: 'ㅅ' },
        { label: "셀커크 렉스", keyword: 'ㅅ' },
        { label: "셀커크 렉스 롱헤어", keyword: 'ㅅ' },
        { label: "소말리", keyword: 'ㅅ' },
        { label: "스노우 슈", keyword: 'ㅅ' },
        { label: "스코티쉬 스트레이트 롱헤어", keyword: 'ㅅ' },
        { label: "스코티쉬 스트레이트", keyword: 'ㅅ' },
        { label: "스코티쉬 폴드", keyword: 'ㅅ' },
        { label: "스코티쉬 폴드 롱헤어", keyword: 'ㅅ' },
        { label: "스핑크스", keyword: 'ㅅ' },
        { label: "시베리안", keyword: 'ㅅ' },
        { label: "싱가푸라", keyword: 'ㅅ' },


        { label: "아메리칸 밥 테일", keyword: 'ㅇ' },
        { label: "아메리칸 밥 테일 숏헤어", keyword: 'ㅇ' },
        { label: "아메리칸 숏헤어", keyword: 'ㅇ' },
        { label: "아메리칸 와이어헤어", keyword: 'ㅇ' },
        { label: "아메리칸 컬", keyword: 'ㅇ' },
        { label: "아메리칸 컬 롱헤어", keyword: 'ㅇ' },
        { label: "아비니시안", keyword: 'ㅇ' },
        { label: "엑조틱", keyword: 'ㅇ' },
        { label: "오리엔탈", keyword: 'ㅇ' },
        { label: "오리엔탈 롱헤어", keyword: 'ㅇ' },
        { label: "오스트레일리안 미스트", keyword: 'ㅇ' },
        { label: "오시캣", keyword: 'ㅇ' },
        { label: "요크 초콜릿", keyword: 'ㅇ' },
        { label: "유러피안 버미즈", keyword: 'ㅇ' },
        { label: "이집션 마우", keyword: 'ㅇ' },

        { label: "자바니즈", keyword: "ㅈ" },
        { label: "재피니즈 밥 테일", keyword: "ㅈ" },
        { label: "재피니즈 밥 테일 롱헤어", keyword: "ㅈ" },

        { label: "차이니스 리 와우", keyword: 'ㅊ' },
        { label: "쵸시", keyword: "ㅊ" },

        { label: "카오마니", keyword: "ㅋ" },
        { label: "캘리포니아 스팽글드", keyword: "ㅋ" },
        { label: "컬러포인트 숏헤어", keyword: "ㅋ" },
        { label: "코시니 렉스", keyword: "ㅋ" },
        { label: "코라트 (코랫)", keyword: "ㅋ" },
        { label: "코리안 숏헤어", keyword: "ㅋ" },
        { label: "쿠릴리안 밥 테일", keyword: "ㅋ" },
        { label: "쿠릴리안 밥 테일 롱헤어", keyword: "ㅋ" },
        { label: "킴릭", keyword: "ㅋ" },

        { label: "타이", keyword: 'ㅌ' },
        { label: "터키시 반", keyword: 'ㅌ' },
        { label: "터키시(터키쉬) 앙고라", keyword: 'ㅌ' },
        { label: "토이거", keyword: 'ㅌ' },
        { label: "통키니즈", keyword: 'ㅌ' },
        { label: "티파니", keyword: 'ㅌ' },

        { label: "페르시안", keyword: "ㅍ" },
        { label: "피터볼드", keyword: "ㅍ" },
        { label: "픽시밥", keyword: "ㅍ" },
        { label: "픽시밥 롱헤어", keyword: "ㅍ" },

        { label: "하나바 브라운", keyword: 'ㅎ' },
        { label: "하이랜더", keyword: 'ㅎ' },
        { label: "하이랜더 숏헤어", keyword: 'ㅎ' },
        { label: "히말라얀", keyword: 'ㅎ' },

        { label: "기타/믹스 고양이", keyword: 'ETC/믹스묘' }
      ],
      admin: {},
      consultList: [
        {
          title: '개인정보보호',
          text: '정보보호 최우선.지정 예약시간 외 광고 전화를 하지 않는 회사'
        },
        {
          title: '전문성/신뢰도',
          text: '41년 경력의 전문성으로 꼭 필요항목으로 설계, 저렴한 회사로 추천'
        },
        {
          title: '고객만족추구',
          text: '홈페이지에는 특정 보험회사 광고 X, 항상 고객의 입장에서 상담'
        },
      ],
      reservation_inflow_referer_source: '',
    }
  },
  watch: {
    'autocomplete.results' () {
    },
    'processorData.steps.0.formData.kind.value' () {
      if(this.processorData.steps[0].formData.kind.value.length == 0) this.autocomplete.status = false
    }
  },
  created() {
    const { date, time } = this.$getDefaultConsultTime();

    if (date !== '') {
      this.processorData.steps[4].formData.consultDate.value = date;
    }

    this.processorData.steps[4].formData.consultTime.value = time;

    if (this.$route.query.refin) {
      this.reservation_inflow_referer_source = this.$route.query.refin;
    }
  },
  methods: {
    submit( finalData ) {
      var tmp = JSON.parse(JSON.stringify(finalData["상담 예약"]));
      // 상담 예약 제거
      delete finalData["상담 예약"];
      //가입자 , 자필서명
      if(this.$route.query) {
        if(this.$route.query.procstep == "가입자" || this.$route.query.procstep == "본인 확인" || this.$route.query.procstep == "자필서명") {
          this.$store.dispatch( "estimate/createItems", finalData);
        }else if(this.$route.query.procstep == "상담 예약") {
          tmp.step_datas.insureName = { value: finalData.title }
          tmp.step_datas.name = {  value: this.processorData.steps[3].formData.name.value }
          tmp.step_datas.phone = { value: this.processorData.steps[3].formData.phone.value}
          var reservation_data = {
            customer_id: finalData.customer_id,
            "전화상담": tmp
          }

          if (this.reservation_inflow_referer_source !== '') {
            reservation_data.reservation_inflow_referer_source = this.reservation_inflow_referer_source;
          }
          // 전화상담 예약 전송
          this.$store.dispatch( "reservation/createItems", reservation_data );
        }
      }
    },
    popup: function( status ) {
      this.statusPopup = status;
    },
    popupSearchPet: function( status ) {
      this.statusSearchPopup = status;
    },
    checkPet: function( value ) {
      this.processorData.steps[0].formData.kind.value = value;
      this.$forceUpdate();
    },
    checkValue: function( value ) {
      var insureOptionsObj = this.processorData.steps[1].formData.insureOptions[this.statusPopup.option];
      insureOptionsObj.items[this.statusPopup.index].subLabel = value;

      var Vidx = insureOptionsObj.value.findIndex(o => o.label === insureOptionsObj.items[this.statusPopup.index].label);
      if(Vidx >= 0){

        if(value === '미가입' && !insureOptionsObj.requirement){
          // 필수 보장항목이 아니고, 미가입하는경우는 value 목록에서 제거
          insureOptionsObj.value.splice(Vidx, 1);
        }else{
          // 이외 값 변경
          // 단, 값이 Array 인경우가 있으므로 확인 ( 다중선택 가능한경우 )
          if(Array.isArray(insureOptionsObj.value[Vidx].value)) {
            var VIidx = insureOptionsObj.value[Vidx].value.indexOf(value);
            // 이미 arr 값이 있는경우 제거
            if(VIidx >= 0){
              //단, 최소 하나이상 선택하도록 해야하므로
              if(insureOptionsObj.value[Vidx].value.length > 0) insureOptionsObj.value[Vidx].value.splice(VIidx, 1);
            }else{
              // 추가
              insureOptionsObj.value[Vidx].value.push(value)
            }
            insureOptionsObj.items[this.statusPopup.index].subLabel = insureOptionsObj.value[Vidx].value.join();
          }else{
            insureOptionsObj.value[Vidx].value = value;
          }
        }
      }else{
        // value 목록에 없는 경우
        if(value != '미가입'){
          // 미가입 아닌경우 값 추가
          var tmp = { label: insureOptionsObj.items[this.statusPopup.index].value, value: value };
          insureOptionsObj.value.push( tmp )
        }
      }
    },
    clickSearch() {
      this.statusSearchPopup = !this.statusSearchPopup;
    },
    updateprocessorData: function (data){
      //this.processorData.steps[3].formData.haslogin.value = data.haslogin;
      this.processorData.steps[3].formData.phone.value = data.phone;
      this.processorData.steps[3].formData.name.value = data.name;
      this.processorData.steps[3].formData.email.value = data.email;
      this.processorData.steps[3].formData.birth.value = data.birth;
    },
    petsearch(value) {
      if(value.length == 0) return;
      this.autocomplete.results = [];
      this.autocomplete.status = false;
      if(this.processorData.steps[0].formData.type.value == "강아지"){
        this.dogList.forEach(o => {
          if(o.label.indexOf(value) >= 0){
            this.autocomplete.results.push({ value: o.label, searchText: value ,splited_texts: o.label.split(value) })
          }
        })
        if(this.autocomplete.results.length > 0)  this.autocomplete.status = true;
      }else if(this.processorData.steps[0].formData.type.value == "고양이"){
        this.catList.forEach(o => {
          if(o.label.indexOf(value) >= 0){

            this.autocomplete.results.push({ value: o.label, searchText: value ,splited_texts: o.label.split(value) })
          }
        })
        if(this.autocomplete.results.length > 0)  this.autocomplete.status = true;
      }
    },
    selectedItem: function ( item ) {
      this.searchText = item.value.value;
      this.autocomplete.status = false;

      var index = this.autocomplete.results.findIndex(o => o.value === this.searchText);
      //this.$emit("searchComplete", this.autocomplete.items[index]);
      this.processorData.steps[0].formData.kind.value = item.value.value
    },
    submitOtherEst() {
      var tmp = {
        customer_id: this.$store.state.customer.profile._id,
        "전화상담": {
          step_datas: {
            insureName: { value: "" },
            name: {  value: this.processorData.steps[3].formData.name.value },
            phone: { value: this.processorData.steps[3].formData.phone.value },
            consultDate: { value: this.processorData.steps[this.processorData.steps.length - 3].formData.consultDate.value },
            consultTime: { value: this.processorData.steps[this.processorData.steps.length - 3].formData.consultTime.value },
            consultRemark: { value: this.processorData.steps[this.processorData.steps.length - 3].formData.consultRemark.value ? this.processorData.steps[this.processorData.steps.length - 3].formData.consultRemark.value : "없음"}
          }
        }
      }
      var ost_data = this.processorData.steps[this.processorData.steps.length - 1];
      if(ost_data.value.length > 0) {
        ost_data.value.forEach(o => {
          tmp["전화상담"].step_datas.insureName.value = o

          if (this.reservation_inflow_referer_source !== '') {
            tmp.reservation_inflow_referer_source = this.reservation_inflow_referer_source;
          }
          
          this.$store.dispatch( "reservation/createItems", tmp );
        })
      }
    },
    getAdminRand(admin) {
      this.admin = admin;
    },
    clickEventHandler() {
      EventBus.$emit('submitProcessor');
    }
  }
}
</script>
